import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-notes",
  templateUrl: "app-notes.component.html",
})
export class AppNotesComponent implements OnInit {
  @Input() notes: string[] = [];
  constructor() {}

  ngOnInit() {}
}
